/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import {
  getBraindateLocation,
  getBraindateConversation,
  getBraindatePath,
} from '@braindate/domain/lib/braindate/util';
import { getTopicPath } from '@braindate/domain/lib/topic/util';
import { isVirtualLocation } from '@braindate/domain/lib/location/util';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './CheckInTakeOver.style';

import type { Braindate } from '@braindate/domain/lib/braindate/type';
import LinkButton from 'src/shared/ui/component/link/LinkButton';
import { isConversationAboutFishbowl } from 'src/shared/domain/conversation/util/conversationUtil';
import { getBraindateTopic } from 'src/shared/domain/braindate/util/braindateUtil';
import messages from 'src/shared/app/check-in/l10n/checkInL10n';
import CameraIcon from 'src/shared/ui/component/icon/CameraIcon';
import CheckInButton from 'src/shared/app/check-in/component/CheckInButton';

type Props = {
  isBraindateCheckInReady: boolean,
  isFetching: boolean,
  braindate: Braindate,
  handleLinkClick: () => void,
};
const useStyles = createUseThemeStyles(styles);

const CheckInActionButtonDumb = ({
  handleLinkClick,
  isBraindateCheckInReady,
  isFetching,
  braindate,
}: Props): React.Node => {
  const intl = useIntl();
  const location = getBraindateLocation(braindate);
  const isVirtual = location && isVirtualLocation(location);
  const classes = useStyles();
  const conversation = getBraindateConversation(braindate);
  const isFishbowl = isConversationAboutFishbowl(conversation);
  const topic = getBraindateTopic(braindate);

  return (
    <>
      {isVirtual ? (
        <LinkButton
          layoutClass={classes.join}
          onClick={handleLinkClick}
          isSubmitting={isFetching}
          isDisabled={!isBraindateCheckInReady}
          to={isFishbowl ? getTopicPath(topic) : getBraindatePath(braindate)}
        >
          <CameraIcon className={classes.joinIcon} />
          {intl.formatMessage(messages.joinVirtual)}
        </LinkButton>
      ) : (
        <CheckInButton braindate={braindate} />
      )}
    </>
  );
};

export default React.memo<Props>(CheckInActionButtonDumb);
